export const getVideoMime = (src: string) => {
    const ext = src.split(".").pop();

    switch (ext) {

        case "mp4":
            return "video/mp4";

        case "webm":
            return "video/webm";

        case "ogg":
            return "video/ogg";

        default:
            return undefined;
    }
};
